import { API } from 'src/utils/interceptor'
import { resolveStoredExVatUnitPrice } from 'src/utils/manualOrderVatHelpers'

const normalizeText = value => String(value || '').trim()

const normalizeProductLine = product => {
  const hasVat = Boolean(product?.hasVat)
  const priceIncludesVat = hasVat && Boolean(product?.priceIncludesVat)
  const enteredPrice = Number.isFinite(Number(product?.OMSPrice))
    ? Number(product.OMSPrice)
    : Number.isFinite(Number(product?.price))
    ? Number(product.price)
    : 0
  const exVatUnit = resolveStoredExVatUnitPrice({
    enteredPrice,
    hasVat,
    priceIncludesVat,
  })

  return {
    ...product,
    product: normalizeText(product?.product),
    title: normalizeText(product?.title),
    sku: normalizeText(product?.sku),
    size: normalizeText(product?.size),
    type: normalizeText(product?.type),
    UoM: normalizeText(product?.UoM),
    quantity:
      Number.isFinite(Number(product?.quantity)) &&
      Number(product?.quantity) > 0
        ? Number(product.quantity)
        : 1,
    price: exVatUnit,
    OMSPrice: exVatUnit,
    hasVat,
    priceIncludesVat,
    nominalCode: normalizeText(product?.nominalCode),
  }
}

export const postPhoneOrders = async data => {
  try {
    const payload = {
      ...data,
      supplier: normalizeText(data?.supplier),
      supplierSageContactNumber: normalizeText(data?.supplierSageContactNumber),
      PONumber: normalizeText(data?.PONumber),
      products: Array.isArray(data?.products)
        ? data.products.map(normalizeProductLine)
        : [],
    }

    const response = await API.post('api', 'venue/phoneOrders', {
      body: payload,
    })
    return response
  } catch (e) {
    console.log(e)
    throw e
  }
}
